export default __webpack_public_path__ + "static/media/app_icon.2d0a24f7.png";